import React, { useState } from 'react';
import { Input, InputGroup, InputGroupAddon, InputProps } from 'reactstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export type PasswordInputProps = Omit<InputProps, 'type'>;

export const PasswordInput = (props: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <InputGroup>
            <Input {...props} type={showPassword ? 'text' : 'password'} />
            <InputGroupAddon addonType="append">
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                    title={showPassword ? 'Hide password' : 'Show password'}
                    onClick={() => setShowPassword(prevState => !prevState)}
                >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
            </InputGroupAddon>
        </InputGroup>
    );
};

export default PasswordInput;
